// Google Analytics/Tag Manager utility functions
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    adsbygoogle: any[];
  }
}

export const GA_TRACKING_ID = 'G-WE28NLF8ZP';
export const GTM_ID = 'GTM-WZSM3S45';
export const GOOGLE_ADS_ID = 'AW-1049756763';

// Initialize gtag
export const gtag = (...args: any[]) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
};

// Track page views
export const pageview = (url: string) => {
  gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

// Track events
export const event = (action: string, parameters?: any) => {
  gtag('event', action, parameters);
};

// Track conversions
export const trackConversion = (conversionId: string, value?: number) => {
  gtag('event', 'conversion', {
    send_to: conversionId,
    value: value,
    currency: 'EUR'
  });
};

// Track the valid conversion label
export const trackValidConversion = (value?: number, additionalData?: any) => {
  gtag('event', 'conversion', {
    send_to: 'AW-1049756763/u8qKCNm3sIIcENuIyPQD',
    value: value || 0,
    currency: 'EUR',
    ...additionalData
  });
};

// Enhanced Google Ads tracking
export const trackReservation = (chateauType: string, price: number) => {
  gtag('event', 'purchase', {
    transaction_id: 'res_' + Date.now(),
    value: price,
    currency: 'EUR',
    items: [{
      item_id: chateauType,
      item_name: chateauType,
      category: 'Château Gonflable',
      quantity: 1,
      price: price
    }]
  });
};

export const trackLead = (formType: 'contact' | 'reservation') => {
  gtag('event', 'generate_lead', {
    currency: 'EUR',
    value: formType === 'reservation' ? 60 : 0,
    form_type: formType
  });
};

export const trackEngagement = (action: string, category: string) => {
  gtag('event', action, {
    event_category: category,
    event_label: window.location.pathname
  });
};